function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_money"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m20 6h-8c-.553 0-1 .447-1 1s.447 1 1 1h8v8c0 .553.447 1 1 1s1-.447 1-1v-8c0-1.103-.897-2-2-2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 12,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 12,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.707 2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l2.293 2.293h-.586c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h12.586l3.707 3.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm.293 13.707v-8h2.586l2.714 2.714c-.19.396-.3.83-.3 1.286 0 1.654 1.346 3 3 3 .456 0 .89-.11 1.286-.3l1.3 1.3z"
})));

var Svg077Nomoney = function Svg077Nomoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg077Nomoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/077-no money.cbef3c9b.svg";
export { ForwardRef as ReactComponent };